module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// Activity_Event_BlogPostEvent Widget

(function (fox, $) {
	
	fox.registerWidget('Activity_Event_CustomEventLocation', {

		configure: function () {

			this.registerOptions('#fullDescription', {
				'template': 'activity_event_card_customevent_location_description'
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this.setOption('template', 'activity_event_card_customevent_location');
			//this.wom1('#fullDescription').setOption('template', 'activity_event_card_customevent_location_description');

			this.callParent('init', arguments);

			var regex = new RegExp("^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?");
			var props = this.p.getMainProperties();
			var url = props.eventTypedParams.url;

			if (!fox.isSet(url)) {
				return;
			};

			if (!!url.match(regex)) {

				if (!url.match(/^http/)) {
					props.eventTypedParams.url = ['http://', url].join('');
				}

				this.p.setOption('eventUrl', true);	
			}

		}

	}, 'Activity_Event_CustomEvent');

})(fox, jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/activity/event/locationEvent.js
// module id = 804
// module chunks = 4